/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'down': {
    width: 200.977,
    height: 200,
    viewBox: '0 0 1029 1024',
    data: '<defs/><path pid="0" d="M682.36 803.271a42.667 42.667 0 00-60.302 0l-65.991 66.56V653.653a42.667 42.667 0 00-85.334 0v216.178l-66.56-66.56a42.667 42.667 0 00-60.302 0 42.098 42.098 0 000 60.302l139.947 139.947a42.667 42.667 0 0029.582 11.947 44.942 44.942 0 0030.151-12.516L682.36 864.142a42.667 42.667 0 000-60.87z"/><path pid="1" d="M765.987 734.436h-95.574a42.667 42.667 0 010-85.334h95.574a164.409 164.409 0 100-328.818 43.236 43.236 0 01-43.236-35.84 207.644 207.644 0 00-413.582 0 43.236 43.236 0 01-42.098 38.685 164.409 164.409 0 000 328.249h69.973a42.667 42.667 0 010 85.333h-67.128a249.173 249.173 0 01-40.392-497.778 293.547 293.547 0 01572.872-1.137 249.742 249.742 0 01-36.41 496.64z"/>'
  }
})
